import classNames from "classnames";
import { useChildrenArray } from "../../lib/helpers/hooks/useChildrenArray";
import { ChevronRightIcon } from "../AscIcons";
import AscOption, { AscOptionProps } from "./AscOption/AscOption";

import styles from "./AscOptionsSelector.module.scss";

type AscOptionsSelectorType = "primary" | "secondary";
type AscOptionsSelectorSize = "medium" | "large";
export interface AscOptionsSelectorProps {
  className?: string;
  children: JSX.Element[];
  value: string | undefined;
  onChange: (active: string) => void;
  type?: AscOptionsSelectorType;
  size?: AscOptionsSelectorSize;
  hideArrowIcon?: boolean;
}

function AscOptionsSelector({
  className,
  children,
  value,
  onChange,
  hideArrowIcon = false,
  type = "primary",
  size = "medium",
}: AscOptionsSelectorProps) {
  const options = useChildrenArray<AscOptionProps>(children);

  return (
    <ul
      data-testid="asc-options-selector"
      className={classNames(
        styles.ground,
        {
          [styles.primary]: type === "primary",
          [styles.secondary]: type === "secondary",
          [styles.medium]: size === "medium",
          [styles.large]: size === "large",
        },
        className
      )}
    >
      {options?.map((option) => {
        return (
          <li
            key={option?.value}
            data-testid="asc-options-selector-option"
            className={classNames(
              styles.option,
              {
                [styles.active]: option?.value === value,
              },
              option?.className
            )}
            onClick={() => {
              if (option?.disabled) {
                return;
              }
              onChange?.(option?.value);
            }}
          >
            {option?.icon ? (
              <div className={styles.iconWrapper}>{option?.icon}</div>
            ) : null}
            <div className={styles.label}>{option?.label}</div>
            {hideArrowIcon ||
            option?.hideArrowIcon ||
            option?.suffixIcon ? null : (
              <ChevronRightIcon className={styles.chevronIcon} />
            )}
            {!option?.suffixIcon ? null : option?.suffixIcon}
          </li>
        );
      })}
    </ul>
  );
}

AscOptionsSelector.Option = AscOption;

export default AscOptionsSelector;
